export default __webpack_public_path__ + "static/media/asaas.d35e35ed.png";